const isLoggedIn = (state) => state.isLoggedIn;
const loginError = (state) => state.loginError;

export default {
    isLoggedIn,
    loginError,
};
